import React from "react"
import styled from "styled-components"
import {Link} from 'gatsby';

const Links = styled.section`
  width: 80%;
  margin-left: 10%;
  padding: 40px 0;
  
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  ul {
    list-style: none;
    padding-left: 0;
  }

  input {
    width: 100%;
  }

  @media screen and (min-width: 850px) {
    section {
      padding: 40px !important;
    }
  }
`

const FooterLinks = () => {
  return (
    <Links>
      <ul>
        <li><h5>LottieMay</h5></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/refunds">Refunds &amp; Exchanges</Link></li>
      </ul>
      <ul>
        <li><h5>Social</h5></li>
        <li><a href="https://www.facebook.com/lottiemayuk/" target="_blank">Facebook</a></li>
        <li><a href="https://www.instagram.com/lottie.may.uk" target="_blank">Instagram</a></li>
      </ul>
      <ul>
        <li><h5>Hampers</h5></li>
        <li><Link to="/all">All Hampers</Link></li>
        <li><Link to="/girls">Baby Girl Hampers</Link></li>
        <li><Link to="/boys">Baby Boy Hampers</Link></li>
        <li><Link to="/unisex">Unisex Hampers</Link></li>
      </ul>
    </Links>
  )
}

export default FooterLinks
